/**
 * @category Model V2
 */
var ReadResourceSequence = /** @class */ (function () {
    /**
     * Represents a sequence of resources.
     *
     * @param resources sequence of resources.
     * @param mayHaveMoreResults flag whether there are more results to be fetched, i.e. for search results.
     */
    function ReadResourceSequence(resources, mayHaveMoreResults) {
        if (mayHaveMoreResults === void 0) { mayHaveMoreResults = false; }
        this.resources = resources;
        this.mayHaveMoreResults = mayHaveMoreResults;
    }
    return ReadResourceSequence;
}());
export { ReadResourceSequence };
